<template>
  <d-col cols="12" md="4" lg="4">
    <label for="currency">
      {{ $t('order.orderCurrency') }}:
    </label>

    <validation-provider
      rules="required"
      name="currency_id"
      v-slot="{ errors }">
      <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
        <v-select
          :options="currencyOptions"
          v-model="currency_id"
          :searchable="false"
          :clearable="false"
          :reduce="currency => currency.value"
          :placeholder="$t('settings.currency.chooseCurrency')"
          label="text">
          <template slot="no-options">
            {{ $t('settings.currency.noCurrenciesAvailable') }}
          </template>
        </v-select>
      </div>

      <div class="invalid-feedback">
        {{ errors[0] }}
      </div>
    </validation-provider>

    <small class="text-primary" v-pure-html="$t('settings.currency.currencyTextWarningText')"></small>
  </d-col>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'order-select-currency',
  computed: {
    currencyOptions () {
      return this.currencies.map(currency => ({
        value: currency.id,
        text: currency.code
      }));
    },
    selectedCurrencySymbol () {
      let selectedCurrency = this.currencies.filter(currency => currency.id === this.currency_id);

      if (selectedCurrency[0]) {
        return selectedCurrency[0].code;
      }

      return '';
    }
  },
  watch: {
    currency_id (newValue) {
      if (newValue !== 0) {
        this.$bus.$emit('order-update-shipment-cost', false);
        this.$bus.$emit('order-reset-custom-prices');
        this.$bus.$emit('order-change-currency');
        this.$bus.$emit('order-update-global-service-prices');
      }
    },
    loadError (newValue) {
      if (newValue) {
        this.$bus.$emit('order-data-fetch-error');
      }
    },
    loadedCurrencies (newValue) {
      if (newValue) {
        this.$bus.$emit('order-data-fetch-success', 'currencies');
      }
    }
  },
  data () {
    return {
      currency_id: null,
      loadedCurrencies: false,
      currencies: [],
      loadError: false
    }
  },
  mounted () {
    FormUtils.loadAdditionalData(this, {
      method: 'get',
      endpoint: '/currencies/items',
      loadedKey: 'loadedCurrencies',
      outputKey: 'currencies',
      errorKey: 'loadError',
      successAction: () => {
        if (this.currency_id === null) {
          this.currency_id = this.currencies[0].id;
        }
      }
    });
  }
}
</script>
